export default {
  // 获取走进jnc
  GET_LIST: '/jcnapi/aboutJcn/getList',
  DEL: '/jcnapi/aboutJcn/delete',
  //保存
  SAVE: '/jcnapi/aboutJcn/save',
  GET: '/jcnapi/aboutJcn/getInfo',
  SET_INFO: '/jcnapi/aboutJcn/setInfo',
  //获取banner
  GET_BANNER: 'jcnapi/aboutJcn/getBanner',
  //设置banner
  SET_BANNER: 'jcnapi/aboutJcn/setBanner',
  //企业简介 保存
  abstract: {
    SAVE: '/jcnapi/aboutJcn/abstract/save',
    GET_LIST: '/jcnapi/aboutJcn/abstract/getList',
    DEL: '/jcnapi/aboutJcn/abstract/delete'
  },
  //应用客户 保存
  customer: {
    SAVE: '/jcnapi/aboutJcn/customer/save',
    GET_LIST: '/jcnapi/aboutJcn/customer/getList',
    DEL: '/jcnapi/aboutJcn/customer/delete'
  },
  //合作伙伴 保存
  partner: {
    SAVE: '/jcnapi/aboutJcn/partner/save',
    GET_LIST: '/jcnapi/aboutJcn/partner/getList',
    DEL: '/jcnapi/aboutJcn/partner/delete'
  }
}

// ./src/data/apiUrl/modules/aboutJcn/index.js



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/aboutJcn/index.js